import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// Provider e connect e também a loja (store)
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import "react-toastify/dist/ReactToastify.css";

// Importar o redux-thunk
import reduxThunk from "redux-thunk";

// Importando o rootReducer
import rootReducer from "./redux/reducers";

const store = createStore(rootReducer, applyMiddleware(reduxThunk));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
